import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const categoryImages: Record<string, string> = {
  "cat-shoes-01": "https://readdy.ai/api/search-image?query=Athletic%20sneakers%20on%20textured%20concrete%20surface%20with%20soft%20shadow%2C%20minimal%20product%20photography%2C%20warm%20neutral%20lighting%2C%20clean%20composition%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-shoes-v2&orientation=squarish",
  "cat-hoodies-02": "https://readdy.ai/api/search-image?query=Oversized%20hoodie%20in%20warm%20sand%20tone%20on%20wooden%20hanger%20against%20clean%20wall%2C%20minimal%20product%20photography%2C%20soft%20natural%20light%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-hoodies-v2&orientation=squarish",
  "cat-tshirts-03": "https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20cotton%20t-shirts%20in%20assorted%20warm%20earthy%20colors%2C%20minimal%20product%20photography%2C%20soft%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-tshirts-v2&orientation=squarish",
  "cat-jackets-04": "https://readdy.ai/api/search-image?query=Lightweight%20bomber%20jacket%20in%20olive%20tone%20displayed%20on%20minimal%20rack%2C%20clean%20product%20photography%2C%20warm%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-jackets-v2&orientation=squarish",
  "cat-pants-05": "https://readdy.ai/api/search-image?query=Folded%20denim%20jeans%20on%20rustic%20wood%20surface%2C%20minimal%20product%20photography%2C%20warm%20natural%20light%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-pants-v2&orientation=squarish",
  "cat-headwear-06": "https://readdy.ai/api/search-image?query=Snapback%20baseball%20cap%20in%20cream%20color%20on%20minimal%20display%2C%20clean%20product%20photography%2C%20soft%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-headwear-v2&orientation=squarish",
  "cat-sets-07": "https://readdy.ai/api/search-image?query=Matching%20two-piece%20athleisure%20set%20in%20soft%20taupe%20on%20mannequin%2C%20minimal%20product%20photography%2C%20warm%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-sets-v2&orientation=squarish",
  "cat-underwear-08": "https://readdy.ai/api/search-image?query=Soft%20cotton%20basics%20folded%20on%20textured%20linen%20surface%2C%20minimal%20product%20photography%2C%20warm%20natural%20light%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-underwear-v2&orientation=squarish",
  "cat-jersey-09": "https://readdy.ai/api/search-image?query=Sports%20jersey%20in%20athletic%20fit%20hanging%20against%20locker%20room%20style%20background%2C%20minimal%20photography%2C%20warm%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-jersey-v2&orientation=squarish",
  "cat-accessories-10": "https://readdy.ai/api/search-image?query=Minimal%20watch%20and%20leather%20bracelet%20on%20marble%20surface%2C%20clean%20product%20photography%2C%20warm%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-accessories-v2&orientation=squarish",
  "cat-bags-11": "https://readdy.ai/api/search-image?query=Stylish%20canvas%20backpack%20on%20urban%20brick%20wall%20background%2C%20minimal%20product%20photography%2C%20warm%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-bags-v2&orientation=squarish",
  "cat-belts-12": "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20coiled%20on%20dark%20slate%20surface%2C%20minimal%20product%20photography%2C%20warm%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-belts-v2&orientation=squarish",
  "cat-perfumes-13": "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20fresh%20flowers%20beside%20on%20marble%2C%20minimal%20photography%2C%20warm%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-perfumes-v2&orientation=squarish",
  "cat-other-14": "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20items%20including%20keychain%20and%20small%20accessories%20on%20minimal%20surface%2C%20clean%20photography%2C%20warm%20lighting%2C%20no%20text%20no%20logos&width=80&height=80&seq=nav-cat-other-v2&orientation=squarish",
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const mobileRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
      if (mobileRef.current && !mobileRef.current.contains(e.target as Node)) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navTextClass = scrolled
    ? "text-foreground-800"
    : "text-white";

  const navBgClass = scrolled
    ? "bg-background-50/95 backdrop-blur-md"
    : "bg-gradient-to-b from-black/35 to-transparent";

  const navBtnClass = scrolled
    ? "border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-white"
    : "border-white/70 text-white hover:bg-white hover:text-foreground-900";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBgClass}`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 py-3.5">
        <Link
          to="/"
          className={`font-heading text-xl md:text-2xl font-bold tracking-tight whitespace-nowrap cursor-pointer transition-colors duration-300 ${navTextClass}`}
        >
          acbuyspreadsheet
        </Link>

        <div className="hidden lg:flex items-center gap-6">
          <Link
            to="/"
            className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 ${navTextClass} hover:opacity-80`}
          >
            Home
          </Link>

          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => {
                setDropdownOpen(!dropdownOpen);
                setMobileMenuOpen(false);
              }}
              className={`flex items-center gap-1.5 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 ${navTextClass} hover:opacity-80`}
            >
              Categories
              <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}>
                <i className="ri-arrow-down-s-line text-sm"></i>
              </span>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full left-0 mt-3 w-64 bg-background-50 rounded-lg py-3 max-h-[480px] overflow-y-auto shadow-sm border border-background-200/70">
                {categories.map((cat) => (
                  <a
                    key={cat.seq}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-4 py-2.5 hover:bg-accent-100/70 transition-colors duration-150 cursor-pointer group"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <div className="w-9 h-9 rounded-md overflow-hidden flex-shrink-0 bg-background-200/50">
                      <img
                        src={categoryImages[cat.seq] || categoryImages["cat-other-14"]}
                        alt={cat.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <span className="text-sm text-foreground-800 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                      {cat.name}
                    </span>
                  </a>
                ))}
              </div>
            )}
          </div>

          <Link
            to="/blog/acbuyspreadsheet-product-sourcing-guide"
            className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 ${navTextClass} hover:opacity-80`}
          >
            Shopping Guide
          </Link>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 hover:opacity-80 ${navTextClass}`}
          >
            acbuy spreadsheet
          </a>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className={`text-sm font-semibold whitespace-nowrap cursor-pointer px-5 py-2 rounded-full border transition-all duration-300 ${navBtnClass}`}
          >
            Buy It Now
          </a>
        </div>

        <div className="flex lg:hidden items-center gap-3">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className={`text-xs font-semibold whitespace-nowrap cursor-pointer px-3.5 py-1.5 rounded-full border transition-all duration-300 ${navBtnClass}`}
          >
            Buy It Now
          </a>
          <button
            className={`w-9 h-9 flex items-center justify-center cursor-pointer ${navTextClass}`}
            onClick={() => {
              setMobileMenuOpen(!mobileMenuOpen);
              setDropdownOpen(false);
            }}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div ref={mobileRef} className="lg:hidden bg-background-50/98 backdrop-blur-md px-6 pb-5 max-h-[70vh] overflow-y-auto border-t border-background-200/50">
          <div className="py-3 border-b border-background-200/70">
            <Link
              to="/"
              className="flex items-center gap-2 py-2.5 text-sm font-medium text-foreground-800 cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-home-4-line text-base"></i>
              </span>
              Home
            </Link>
            <Link
              to="/blog/acbuyspreadsheet-product-sourcing-guide"
              className="flex items-center gap-2 py-2.5 text-sm font-medium text-foreground-800 cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-book-open-line text-base"></i>
              </span>
              Shopping Guide
            </Link>
          </div>

          <div className="py-3 border-b border-background-200/70">
            <p className="text-xs text-foreground-500 uppercase tracking-wider mb-2 font-medium">Categories</p>
            <div className="grid grid-cols-2 gap-1">
              {categories.map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 py-2 px-1 rounded-md hover:bg-accent-100/70 transition-colors cursor-pointer"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <div className="w-7 h-7 rounded overflow-hidden flex-shrink-0 bg-background-200/50">
                    <img
                      src={categoryImages[cat.seq] || categoryImages["cat-other-14"]}
                      alt={cat.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <span className="text-xs text-foreground-700 leading-tight">{cat.name}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="pt-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="block py-2.5 text-sm font-medium text-foreground-800 cursor-pointer"
            >
              acbuy spreadsheet &rarr;
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}